import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "d-flex flex-col flex-no-wrap h-100 overflow-y-auto m-t-32"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("Back To Video")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicWaitingRoomOverlay = _resolveComponent("PublicWaitingRoomOverlay")!
  const _component_ContentWrapper = _resolveComponent("ContentWrapper")!
  const _component_app_chip = _resolveComponent("app-chip")!
  const _component_PatientTelehealthHeader = _resolveComponent("PatientTelehealthHeader")!
  const _component_ChatView = _resolveComponent("ChatView")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, { ref: "ionPage" }, {
    default: _withCtx(() => [
      (!_ctx.inRoom())
        ? (_openBlock(), _createBlock(_Transition, {
            key: 0,
            name: "fade"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ContentWrapper, null, {
                "content-top": _withCtx(() => [
                  (!_ctx.inRoom())
                    ? (_openBlock(), _createBlock(_component_PublicWaitingRoomOverlay, {
                        key: 0,
                        onExit: _ctx.onExit,
                        isLoading: !_ctx.callOver,
                        failure: null
                      }, null, 8, ["onExit", "isLoading"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_PatientTelehealthHeader, { onExit: _ctx.onExit }, {
              default: _withCtx(() => [
                _createVNode(_component_app_chip, {
                  id: "chat-toggle",
                  onClick: _ctx.toggleChat
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["onExit"]),
            _createVNode(_component_ChatView, {
              class: "flex-item-grow m-l-16 m-r-16",
              onSend: _ctx.sendTextMessage,
              onInput: _ctx.signalTyping,
              typing: _ctx.remoteTyping,
              "chat-items": _ctx.chatItems,
              disabled: false
            }, null, 8, ["onSend", "onInput", "typing", "chat-items"])
          ]))
    ]),
    _: 1
  }, 512))
}